module.exports = __WEBPACK_EXTERNAL_MODULE__atlas_api_javascript_sdk_no_splm__;